module.exports = __webpack_public_path__ + "img/var_04_cursor.20b4da85.png";